// extracted by mini-css-extract-plugin
export default {"container":"Mobile_container__2XDql","middle":"Mobile_middle__5zzdd"};